import { Input, MapperFlexibleFrequency, Output, Rule } from './types';

const mappingRules: Record<MapperFlexibleFrequency, Rule> = {
  weekly: {
    fromInput: (input) => ({
      dayOfWeek: input.daysOfWeek?.find(Boolean),
    }),
    toInput: (output) => ({
      daysOfWeek: output.dayOfWeek ? [output.dayOfWeek] : [],
    }),
  },
  biWeekly: {
    fromInput: (input) => ({
      dayOfWeek: input.daysOfWeek?.find(Boolean),
      biweeklyDate: '',
    }),
    toInput: (output) => ({
      daysOfWeek: output.dayOfWeek ? [output.dayOfWeek] : [],
    }),
  },
  semiMonthly: {
    fromInput: (input) => ({
      semiMonthlyDates: input.daysOfMonth?.filter(Boolean).join(','),
    }),
    toInput: (output) => ({
      daysOfMonth: output.semiMonthlyDates
        ? output.semiMonthlyDates.split(',').map(Number)
        : [],
    }),
  },
  monthly: {
    fromInput: (input) => ({
      monthly: input.daysOfMonth?.find(Boolean)?.toString(),
    }),
    toInput: (output) => ({
      daysOfMonth: output.monthly ? [parseInt(output.monthly, 10)] : [],
    }),
  },
  fullPay: {
    fromInput: () => ({
      dayOfWeek: undefined,
      biweeklyDate: undefined,
      semiMonthlyDates: undefined,
      monthly: undefined,
    }),
    toInput: () => ({
      daysOfWeek: [],
      daysOfMonth: [],
    }),
  },
};

export const fromInputToOutput = (input: Input): Output => {
  const base: Output = {
    frequency: input.frequency,
    dayOfWeek: undefined,
    biweeklyDate: undefined,
    semiMonthlyDates: undefined,
    monthly: undefined,
  };

  return {
    ...base,
    ...mappingRules[input.frequency].fromInput(input),
  };
};

export const fromOutputToInput = (output: Output): Input => {
  const defaultFrequency = 'monthly' as MapperFlexibleFrequency;
  const base: Input = {
    frequency: output?.frequency || defaultFrequency,
    daysOfWeek: undefined,
    daysOfMonth: undefined,
  };

  return {
    frequency: base.frequency,
    ...mappingRules[base.frequency].toInput(output),
  };
};
